import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductionDetailsSearchComponent } from './production-details-search/production-details-search.component';
import { TeamProductionDetailsSearchComponent } from './team-production-details-search/team-production-details-search.component';
import { AuthGuardService } from '../auth-guard.service';

const routes: Routes = [
  {
    path: 'search-production-details',
    component: ProductionDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-production-details/:agentId',
    component: ProductionDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'search-team-production-details',
    component: TeamProductionDetailsSearchComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class ProductionRoutingModule {}
